var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 24.75 0.5)",
    fill: "#AE0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5502 12.4997C14.5502 12.423 14.5209 12.3462 14.4623 12.2876L11.4623 9.28763C11.3451 9.1704 11.1553 9.1704 11.0381 9.28763C10.921 9.40485 10.9209 9.59468 11.0381 9.71183L13.826 12.4997L11.0381 15.2876C10.9209 15.4049 10.9209 15.5947 11.0381 15.7118C11.1553 15.829 11.3452 15.8291 11.4623 15.7118L14.4623 12.7118C14.5209 12.6533 14.5502 12.5765 14.5502 12.4997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRed);
export default __webpack_public_path__ + "static/media/chevron-red.fc5d04888ea63eea4012b7d11b000b9c.svg";
export { ForwardRef as ReactComponent };